import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "skeleton-lines" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.supportsResizer && !_ctx.noSize)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "dynamic-img-container",
        ref: "dynamicImgContainer",
        style: _normalizeStyle({height: `${_ctx.container.height}px`})
      }, [
        (!_ctx.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getLinesCount, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _ctx.image
            }, null, 8, _hoisted_3))
      ], 4))
    : (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: _ctx.image
      }, null, 8, _hoisted_4))
}